import { memo } from 'react'

import { SVGProps } from './types/iconType'

export const PlayIcon = memo(({ style, className }: SVGProps) => {
  return (
    <svg className={className} style={style} viewBox="0 0 40 40" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M34.54 13.33 13.07 1.02A7.602 7.602 0 0 0 1.666 7.686v24.713C1.667 36.597 5.07 40 9.268 40a7.624 7.624 0 0 0 3.801-1.022l21.47-12.313a7.6 7.6 0 0 0 0-13.156v-.178zm-2.223 9.313-21.47 12.49a3.2 3.2 0 0 1-3.157 0 3.156 3.156 0 0 1-1.578-2.734V7.597c0-1.128.602-2.17 1.578-2.734a3.356 3.356 0 0 1 1.578-.422 3.423 3.423 0 0 1 1.579.422l21.47 12.402a3.156 3.156 0 0 1 0 5.467v-.09z"
        fillRule="evenodd"
      />
    </svg>
  )
})
